<template>
  <div class="upload-file">
    <el-upload
      v-if="dialogType != 'see'" :disabled="zzscwj"
      class="upload-demo"
      drag
      :action="htmlType == 1 ? uploadFileUrl1 : uploadFileUrl"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-progress="handleProgress"
      :show-file-list="false"
      :headers="headers"
      ref="fileUpload"
      multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传
        <template v-if="fileSize && htmlType == '2'"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
        <template v-if="fileSize && htmlType == '1'"> 大小不超过 <b style="color: #f56c6c">2GB</b> </template>
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
        的文件
      </div>
      <el-progress v-if="showProgress" :percentage="progressPercent" :status="progressStatus"></el-progress>

    </el-upload>

    <!-- 文件列表 -->
    <!-- <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul">
      <li :key="file.url" class="el-upload-list__item ele-upload-list__item-content" v-for="(file, index) in fileList">
        <el-link :href="`${baseUrl}${file.url}`" :underline="false" target="_blank">
          <span class="el-icon-document"> {{ getFileName(file.name) }} </span>
        </el-link>
        <div class="ele-upload-list__item-content-action">
          <el-link :underline="false" @click="handleDelete(index)" type="danger">删除</el-link>
        </div>
      </li>
    </transition-group> -->
    <div style="display: flex;flex-wrap: wrap;width: 100%;">
      <li v-for="(file, index) in fileList" :key="index" style="width: 3.6rem;margin-top: .2rem;margin-right:.1rem;">
        <video controls v-if="file.url.slice(file.url.indexOf('.')) == '.mp4'" style="width: 3.6rem;height: 1.8rem;" :src="`${baseUrl}${file.url}`"></video>
        <el-image v-else :fit="'contain'" style="width: 3.6rem;height: 1.8rem;" :src="`${baseUrl}${file.url}`"></el-image>
        <el-input v-if="htmlType == 1" v-model="file.duration1" placeholder="输入时长" style="width: 100%;margin-top: .1rem;" readonly></el-input>
        <el-input v-if="htmlType == 1" v-model="file.videoChildTitle" placeholder="输入视频名称" style="width: 100%;margin-top: .1rem;" @input="changeinput(index,$event)"></el-input>
        <el-input v-if="htmlType == 3" v-model="file.videoTitle" placeholder="输入视频名称" style="width: 100%;margin-top: .1rem;" @input="changeinput1(index,$event)"></el-input>
        <div class="ele-upload-list__item-content-action" v-if="dialogType != 'see'" style="display: flex;justify-content: center;">
          <el-link :underline="false" @click="handleDelete(index)" type="danger">删除</el-link>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { Loading } from 'element-ui';
export default {
  name: "FileUpload",
  props: {
    progressPercent: 0,
    showProgress: false,
    progressStatus: 'success',
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 10,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 2000,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['mp4'],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 是否展示输入框
    htmlType: {
      type: Number,
      default: 1,
    },
    // 是否显示删除按钮
    dialogType:{
      type:String,
      default:'edit'
    },
  },
  data() {
    return {
      zzscwj:false,
      number: 0,
      uploadList: [],
      baseUrl: '',
      //本地-开发环境设为
      // uploadFileUrl: this.$globalPath+"/common/upload",
      // uploadFileUrl1: this.$globalPath+"/common/uploadHaveDuration", 

      //线上-部署上线设为  线上cdn限制，只能更换别的域名去传
      uploadFileUrl: "https://m.sxmszx.com:8086/common/upload",
      uploadFileUrl1: "https://m.sxmszx.com:8086/common/uploadHaveDuration",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      fileList: [],
      alllength:0
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              item = { name: item, url: item };
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    handleProgress(event, file, fileList) {
      this.showProgress = true;
      this.progressPercent = Math.floor(event.loaded / event.total * 100);
      if(this.progressPercent>0 && this.progressStatus!='success'){
        this.progressPercent = this.progressPercent-1
      }
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.zzscwj = true;
      // this.loadingInstance = Loading.service({
      //   lock: true,
      //   text: "正在上传文件，请稍候...",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // })
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.progressStatus = 'exception';
      this.$message.error("上传失败，请重试");
      this.zzscwj = false;
      this.loadingInstance.close();
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      if (res.code === 200) {
        
        // if(res.length){
        //   let hours = Math.floor(res.length / 3600000);
        //   let minutes = Math.floor((res.length % 3600000) / 60000);
        //   let seconds = Math.floor(((res.length % 3600000) % 60000) / 1000);
        //   var duration = hours + ':' + minutes + ':' + seconds;
        //   var duration1 = hours + '时' + minutes + '分' + seconds + '秒'
        // }
        this.uploadList.push({ name: res.fileName, url: res.fileName,length:res.length});
        this.uploadedSuccessfully("success");
      } else {
        this.zzscwj = false;
        this.number--;
        this.loadingInstance.close();
        this.$message.error(res.msg);
        this.$refs.fileUpload.handleRemove(file);
        this.uploadedSuccessfully('fail');
      }
    },
    
    // 删除文件
    handleDelete(index) {
      this.alllength = 0
      this.fileList.splice(index, 1);
      if(this.fileList.length != 0){
          this.fileList.map(item =>{
            console.log(item.length,99999)
            if(item.length){
              item.seconds = parseInt(item.length, 10)
              let hours = Math.floor(item.seconds / 3600);
              let minutes = Math.floor((item.seconds % 3600000) / 60);
              let seconds = item.seconds - (hours * 3600) - (minutes * 60)
              item.duration = hours + ':' + minutes + ':' + seconds
              item.duration1 = hours + '时' + minutes + '分' + seconds + '秒'
              this.alllength += item.length
            }
          })
        }else{
          this.alllength = 0
        }
      console.log(this.fileList,41546)
      this.$emit('alllength',this.alllength)
      this.$emit("input",this.fileList);
    },
    // 上传结束处理
    uploadedSuccessfully(state) {
      this.alllength = 0
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        if(this.fileList.length != 0){
          this.fileList.map(item =>{
            console.log(item.length,99999)
            if(item.length){
              item.seconds = parseInt(item.length, 10)
              let hours = Math.floor(item.seconds / 3600);
              let minutes = Math.floor((item.seconds % 3600000) / 60);
              let seconds = item.seconds - (hours * 3600) - (minutes * 60)
              item.duration = hours + ':' + minutes + ':' + seconds
              item.duration1 = hours + '时' + minutes + '分' + seconds + '秒'
              this.alllength += item.length
            }
          })
        }else{
          this.alllength = 0
        }
        this.uploadList = [];
        this.number = 0;
        console.log(this.alllength,777)
        this.$emit('alllength',this.alllength)
        this.$emit("input",this.fileList);
        console.log(this.fileList,66666)
        
        if(state=='success'){
          this.progressStatus = 'success';
        }else{
          this.progressStatus = 'exception';
        }
        this.zzscwj = false;
        this.loadingInstance.close();
      }
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        var firstname = name.slice(name.lastIndexOf("/") + 1)
        var lastdian = name.slice(name.lastIndexOf(".") + 1)
        var lastname = firstname.slice(0,firstname.lastIndexOf('.'))
        const lastUnderscoreIndex = lastname.lastIndexOf('_');
        if(lastname.lastIndexOf('_') > -1){
          var threename = lastname.slice(0,lastUnderscoreIndex)
        }
        var fourname = threename + '.' + lastdian
        return fourname;
      } else {
        return "";
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      console.log(list,9898989)
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      console.log(strs,'=======')
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    },
    changeinput1(index,e){
      this.$nextTick(() => {
        this.fileList[index].videoTitle = e;
        this.$forceUpdate();
        console.log(this.fileList,7878)
      });
    },
    changeinput(index,e){
      this.$nextTick(() => {
        this.fileList[index].videoChildTitle = e;
        this.$forceUpdate();
        console.log(this.fileList,7878)
      });
    }
  }
};
</script>

<style scoped>
.upload-file-uploader {
  margin-bottom: .05rem;
}
.upload-file-list .el-upload-list__item {
  border: .01rem solid #e4e7ed;
  line-height: 2;
  margin-bottom: .1rem;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload/index.vue